var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_19506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_19506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7822 11.575L14.6822 15.475C14.8656 15.6583 14.9572 15.8917 14.9572 16.175C14.9572 16.4583 14.8656 16.6917 14.6822 16.875C14.4989 17.0583 14.2656 17.15 13.9822 17.15C13.6989 17.15 13.4656 17.0583 13.2822 16.875L8.68223 12.275C8.58223 12.175 8.51139 12.0667 8.46973 11.95C8.42806 11.8333 8.40723 11.7083 8.40723 11.575C8.40723 11.4417 8.42806 11.3167 8.46973 11.2C8.51139 11.0833 8.58223 10.975 8.68223 10.875L13.2822 6.275C13.4656 6.09167 13.6989 6 13.9822 6C14.2656 6 14.4989 6.09167 14.6822 6.275C14.8656 6.45833 14.9572 6.69167 14.9572 6.975C14.9572 7.25833 14.8656 7.49167 14.6822 7.675L10.7822 11.575Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.d773086d0a0c257905bb7efe15d83598.svg";
export { ForwardRef as ReactComponent };